'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.dispatchAction = dispatchAction;

var _configStorage = require('./internal/config-storage');

var _configStorage2 = _interopRequireDefault(_configStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var store = (0, _configStorage2.default)({});
exports.default = store;
function dispatchAction(action) {
	var s = store.get();
	if (s && typeof s.dispatch === 'function') {
		s.dispatch(action);
	}
}


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/core/store.js
// module id = 87
// module chunks = 0